/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Col, Row, Container } from '@zillow/zrs-comet';
import { Button } from '@zillow/constellation';

import BillingFilterPill from 'app/shared/components/Billing/BillingFilterPill';

import './style.scss';

const propTypes = {
    isFilterOpen: PropTypes.bool,
    handleFilterToggle: PropTypes.func,
    handleSaveFilters: PropTypes.func,
    initialFilters: PropTypes.object,
};

const defaultProps = {
    isFilterOpen: false,
    handleFilterToggle: () => { },
    handleSaveFilters: () => { },
    initialFilters: {},
};

const BillingFilter = ({
    isFilterOpen, handleFilterToggle, initialFilters, handleSaveFilters,
}) => {
    const [filters, setFilters] = React.useState(initialFilters);
    const wrapperRef = React.useRef(null);
    const lastFilterState = React.useRef(false);
    const controlsRef = React.useRef(null);
    if (Object.values(initialFilters).length === 0) return null;

    // Update the filters before closing or opening
    if (isFilterOpen !== lastFilterState.current) {
        lastFilterState.current = isFilterOpen;
        setFilters(initialFilters);
    }

    const updateFilters = (key, value, save) => {
        const newFilters = {
            ...filters,
            [key]: {
                ...filters[key],
                value,
            },
        };
        setFilters(newFilters);
        if (save) handleSaveFilters(newFilters);
    };

    const renderPills = () => {
        const pills = [];
        for (const [key, filter] of Object.entries(filters)) {
            const FilterPill = BillingFilterPill[filter.type];
            pills.push(
                <FilterPill
                    key={key}
                    keyName={key}
                    isFilterOpen={isFilterOpen}
                    value={filter.value}
                    title={filter.title}
                    type={filter.type}
                    defaultValue={filter.defaultValue}
                    handleChange={value => updateFilters(key, value)}
                    handleClose={value => updateFilters(key, value, true)}
                    filters={filters}
                    {...(filter.extraProps && filter.extraProps)}
                />
            );
        }
        return pills;
    };

    const anyFilterOpen = (Object.values(filters)).some((filter) => {
        if (Array.isArray(filter.value)) {
            return filter.value.some(subValue => subValue.isChecked);
        }
        return filter.value !== null;
    });

    return (
        <Container>
            <div ref={wrapperRef} className="BillingFilter">
                <div
                    ref={controlsRef}
                    className={cx('BillingFilter-controls-wrapper', {
                        'BillingFilter-top-border': anyFilterOpen,
                        'BillingFilter-controls-edit': isFilterOpen,
                    })}
                >
                    <Row className={cx('BillingFilter-controls', {
                        'BillingFilter-controls-open': isFilterOpen,
                    })}
                    >
                        {renderPills()}
                    </Row>
                    {isFilterOpen && (
                        <Row className="BillingFilter-controls-open">
                            <Col xs={12}>
                                <div
                                    className="BillingFilter-controls-footer"
                                >
                                    <Button
                                        onClick={handleFilterToggle}
                                        buttonType="secondary"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        buttonType="primary"
                                        onClick={() => handleSaveFilters(filters)}
                                    >
                                        Apply
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    )}
                </div>
            </div>
        </Container>
    );
};

BillingFilter.propTypes = propTypes;
BillingFilter.defaultProps = defaultProps;

export default BillingFilter;
